export default __webpack_public_path__ + "static/whole-body-d732e9e3ac5c79eced085d0388cb053e.png";